import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { IonContent, IonPage } from "@ionic/vue";
import SidebarComponent from "@/modules/General/components/SidebarComponent.vue";
import DesktopHeader from "@/modules/General/components/DesktopHeader.vue";
import {useBreakpoint} from "@/hooks/useBreakpoint";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  props: {
    light: { type: Boolean },
    hideDesktopHeader: { type: Boolean },
    isSearchAvailable: { type: Boolean }
  },
  setup(__props: any) {



const { isDesktop } = useBreakpoint();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), {
    id: "main-content",
    class: "page"
  }, {
    default: _withCtx(() => [
      (_unref(isDesktop) && !_ctx.hideDesktopHeader)
        ? (_openBlock(), _createBlock(DesktopHeader, {
            key: 0,
            "is-search-available": _ctx.isSearchAvailable
          }, null, 8, ["is-search-available"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "header"),
      _createVNode(_unref(IonContent), {
        class: _normalizeClass([{'main-content--light': _ctx.light}, "main-content"])
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]),
      _createVNode(SidebarComponent)
    ]),
    _: 3
  }))
}
}

})